let prefix = 'bcx-aurelia-reorderable-repeat:';

export default function(ref) {
  return prefix + ref;
}
